import { observePerformance } from './observe-performance';
import { PERFORMANCE_ENTRY_TYPES } from './constants';
// 监听长任务和资源请求
export const observeLongTaskAndResources = (onLongTask, onNetworkRequest) => {
    observePerformance({
        entryTypes: [PERFORMANCE_ENTRY_TYPES.LONG_TASK, PERFORMANCE_ENTRY_TYPES.RESOURCE],
    }, (entryList) => {
        for (const entry of entryList) {
            const { startTime, duration, entryType } = entry;
            if (entryType === PERFORMANCE_ENTRY_TYPES.LONG_TASK) {
                onLongTask({
                    startTime: startTime,
                    endTime: startTime + duration,
                }, entry);
            }
            else if (entry.entryType === PERFORMANCE_ENTRY_TYPES.RESOURCE) {
                const { fetchStart, responseEnd } = entry;
                onNetworkRequest({
                    startTime: fetchStart,
                    endTime: responseEnd,
                }, entry);
            }
        }
    });
};
